module.exports = __webpack_public_path__ + "img/background-overview-card-button-gradient.53e9f161.png";